export interface ResolveColorOrderInput {
  allKnownValues: readonly string[];
  headerColorOrder: readonly string[];
  displayOrder: readonly string[] | undefined;
}

export interface ResolveColorOrderOutput {
  stableOrderedValues: string[];
  valueToColorIndex: Record<string, number>;
}

function reorderByPriority(values: readonly string[], priority: readonly string[]): string[] {
  const valueSet = new Set(values);
  const seen = new Set<string>();
  const ordered: string[] = [];

  for (const id of priority) {
    if (valueSet.has(id) && !seen.has(id)) {
      ordered.push(id);
      seen.add(id);
    }
  }

  for (const value of values) {
    if (!seen.has(value)) {
      ordered.push(value);
    }
  }

  return ordered;
}

export function resolveColorOrder({
  allKnownValues,
  headerColorOrder,
  displayOrder,
}: ResolveColorOrderInput): ResolveColorOrderOutput {
  if (allKnownValues.length === 0) {
    return { stableOrderedValues: [], valueToColorIndex: {} };
  }

  const hasRelevantSavedOrder =
    headerColorOrder.length > 0 && headerColorOrder.some((value) => allKnownValues.includes(value));

  const priority = hasRelevantSavedOrder
    ? headerColorOrder
    : displayOrder?.length
      ? displayOrder
      : undefined;

  const stableOrderedValues = priority
    ? reorderByPriority(allKnownValues, priority)
    : [...allKnownValues];

  const valueToColorIndex: Record<string, number> = {};
  stableOrderedValues.forEach((value, index) => {
    valueToColorIndex[value] = index;
  });

  return { stableOrderedValues, valueToColorIndex };
}
